import React from 'react';

function WizardParagraph({ text, customStyle = null }) {
  return (
    <p
      id={`wizardparagraph-${text}`}
      data-testid={`wizardparagraph-${text}`}
      style={{
        fontSize: '1.125rem',
        lineHeight: '1.315rem',
        color: '#000000',
        textAlign: 'center',
        ...customStyle,
      }}
    >
      {text}
    </p>
  );
}

export default WizardParagraph;
